import React from 'react';
import { ReactComponent as ImageIcon } from 'src/assets/icons/image.svg';
import { ReactComponent as VideoIcon } from 'src/assets/icons/video.svg';
import { ReactComponent as FileDocumentIcon } from 'src/assets/icons/file-document.svg';

export const getFileIcon = (
    type: string,
    width = 16,
    height = 16
): React.ReactElement => {
    if (type.startsWith('image/')) {
        return <ImageIcon width={width} height={height} />;
    } else if (type.startsWith('video/')) {
        return <VideoIcon width={width} height={height} />;
    } else {
        return <FileDocumentIcon width={width} height={height} />;
    }
};
